import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { MAIN_URL } from '../../constants';
import { SortableContext, verticalListSortingStrategy, arrayMove } from "@dnd-kit/sortable";
import SortableLesson from "./SortableLesson";
import React, { useState, useEffect } from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import api from "../../Components/RefreshToken/RefreshToken";
import axios from "axios";
import { toast } from "react-toastify";
import { ChevronDown, GripVertical, Pencil, Trash2 } from "lucide-react";
import { Button, Modal, Spinner } from "../../Components/ui";

const SortableChapter = ({
  chapter,
  index,
  handleChapter,
  activeChapter,
  chapterEdit,
  handleChapterEdit,
  handleFileChange,
  handleUpCapter,
  updateChapter,
  chapterUpLoad,
  setChapterName,
  chapterName,
  chapterFile,
  lessons,
  handleLessonClick,
  onOpenTranslationModal,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: chapter.id });
  const [sortedLessons, setSortedLessons] = useState([]);
  const [isOrderChanged, setIsOrderChanged] = useState(false)
  const TOKEN = localStorage.getItem("admin_token")
  const [deletedIsOpen, setDeletedIsopen] = useState(false)
  const [chapterId, setChapterId] = useState(0)

  // chapter.translations = [{id:32, title:"...", language:"uz"}, ...]
  // title faqat translations ichida, chapter.title yo'q
  // Ko'rsatish uchun: avval activeLanguage tilini, bo'lmasa birinchisini olamiz
  const getChapterTitle = () => {
    if (!Array.isArray(chapter.translations) || chapter.translations.length === 0) {
      return chapter.title || "—";
    }
    // Avval uz, keyin ru, keyin en, keyin birinchisi
    const preferred = ["uz", "ru", "en"];
    for (const lang of preferred) {
      const t = chapter.translations.find((t) => t.language === lang);
      if (t?.title) return t.title;
    }
    return chapter.translations[0]?.title || "—";
  };

  useEffect(() => {
    if (isOrderChanged) {
      api.post(
        `${MAIN_URL}/courses/lessons/change-order`,
        sortedLessons.map((lesson, i) => ({ id: lesson.id, order: i + 1 })),
        { headers: { "Content-Type": "application/json", Authorization: `Bearer ${TOKEN}` } }
      )
        .then((res) => {
          setIsOrderChanged(false);
          setSortedLessons((prev) => prev.map((lesson, i) => ({ ...lesson, order: i + 1 })));
        })
        .catch((err) => console.error("Error:", err));
    }
  }, [isOrderChanged]);

  useEffect(() => {
    if (!Array.isArray(lessons)) { setSortedLessons([]); return; }
    setSortedLessons([...lessons].sort((a, b) => a.order - b.order));
  }, [lessons]);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    setSortedLessons((prev) => {
      const oldIndex = prev.findIndex((l) => l.id === active.id);
      const newIndex = prev.findIndex((l) => l.id === over.id);
      return arrayMove(prev, oldIndex, newIndex);
    });
    setIsOrderChanged(true);
  };

  // dnd-kit pozitsiyasi (transform/transition) — ko'rinish CSS'da (.ui-chapter)
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const isOpenDelete = () => setDeletedIsopen(x => !x)

  const deletedChapter = () => {
    axios.delete(`${MAIN_URL}/courses/chapters/${chapterId}`, {
      headers: { "Content-type": "application/json", Authorization: `Bearer ${TOKEN}` },
    }).then(() => {
      setDeletedIsopen(false);
      toast.success('Deleted!!!');
      window.location.reload();
    }).catch((err) => console.log(err))
  }

  const isOpen = activeChapter === index;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`ui-chapter ${isOpen ? "ui-chapter--open" : ""} ${isDragging ? "ui-chapter--dragging" : ""}`}
    >
      {/* ─── Chapter sarlavha qatori (bosilganda ochiladi/yopiladi) ─── */}
      <div className="ui-chapter__row" onClick={() => handleChapter(chapter?.id, index)}>
        {/* ─── Drag icon ─── */}
        {activeChapter !== index && chapterEdit !== index && (
          <span className="ui-chapter__handle" {...attributes} {...listeners} aria-label="Bobni sudrash">
            <GripVertical aria-hidden="true" />
          </span>
        )}

        {/* Title — translations ichidan olinadi */}
        <span className="ui-chapter__title">{getChapterTitle()}</span>
        {isOpen && Array.isArray(lessons) && (
          <span className="ui-chapter__meta">{lessons.length} ta dars</span>
        )}

        <span className="ui-chapter__actions">
          {chapterUpLoad ? (
            <Spinner size="sm" label="Yuklanmoqda" />
          ) : (
            /* Qalam — Chapter Translation Modal ochadi */
            <Button
              variant="ghost"
              size="sm"
              iconOnly
              aria-label="Bobni tahrirlash"
              onClick={(e) => {
                e.stopPropagation();
                if (onOpenTranslationModal) onOpenTranslationModal(chapter);
              }}
            >
              <Pencil />
            </Button>
          )}

          {/* O'chirish */}
          <Button
            variant="ghost"
            size="sm"
            iconOnly
            aria-label="Bobni o'chirish"
            className="ui-edit-course__danger-icon"
            onClick={(e) => { e.stopPropagation(); isOpenDelete(); setChapterId(chapter.id); }}
          >
            <Trash2 />
          </Button>
          <ChevronDown className="ui-chapter__chevron" aria-hidden="true" />
        </span>
      </div>

      {/* ─── Lessons ro'yxati ─── */}
      {isOpen && (
        <div className="ui-chapter__lessons" onClick={(e) => e.stopPropagation()}>
          {(!lessons || lessons.length === 0) ? (
            <p className="ui-chapter__empty">Bu bobda darslar yo'q</p>
          ) : (
            <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
              <SortableContext
                items={sortedLessons.map((l) => l.id)}
                strategy={verticalListSortingStrategy}
              >
                {sortedLessons.map((lesson, lessonIndex) => (
                  <SortableLesson
                    key={lesson.id}
                    lesson={lesson}
                    index={lessonIndex}
                    handleLessonClick={handleLessonClick}
                    chapterId={chapter.id}
                  />
                ))}
              </SortableContext>
            </DndContext>
          )}
        </div>
      )}

      {/* ─── O'chirish modali ─── */}
      <Modal
        open={deletedIsOpen}
        onClose={isOpenDelete}
        title="Bobni o'chirasizmi?"
        size="sm"
        footer={
          <>
            <Button variant="secondary" onClick={isOpenDelete}>Bekor qilish</Button>
            <Button variant="danger-solid" leftIcon={<Trash2 />} onClick={deletedChapter}>O'chirish</Button>
          </>
        }
      >
        <p className="ui-edit-course__modal-name">{getChapterTitle()}</p>
        <p className="ui-edit-course__modal-text">Bu amalni ortga qaytarib bo'lmaydi.</p>
      </Modal>
    </div>
  );
};

export default SortableChapter;